import { createCityPlans } from '../../../Module/graphQL'
import { normalizeGraphQLConnection } from '../../../shared/graphql/utils'

export const createCityPlansGQLHandler = async input => {
  if (!input.length) return []
  const response = await createCityPlans(input)
  const { data, errors } = await response.json()
  if (errors && errors.length) {
    throw data.errors[0].message
  }
  return data.createCityPlans.cityPlans
}

export const formatData = data => {
  const existingCityIds = data.campaign.cityPlans.nodes.map(
    ({ city }) => city.id,
  )

  return {
    campaign: data.campaign,
    uniqueCitiesList: normalizeGraphQLConnection(
      data.campaign.country.cities,
    ).filter(city => !existingCityIds.includes(city.id)),
  }
}
